import React, { useEffect, useRef, useState } from 'react';
import SearchAndFilterBlogs from '../SearchAndFilterBlogs/SearchAndFilterBlogs';
import CategoryBlogCard from './CategoryBlogCard';
import Pagination from '../../../../shared-components/Pagination/Pagination';
import scrollToElement from '../../../../utils/scrollIntoView';
import { BlogCity, CategoryBlogPost } from '../../../../pages/blog';
import Image from 'next/image';
import { useRouter } from 'next/router';

interface ExploreByCityProps {
  blogs: CategoryBlogPost[] | undefined;
  currentPage: number;
  totalPages: number;
  onPageChange: React.Dispatch<React.SetStateAction<number>>;
  onCityChange: (newCityId: string) => void;
  cities: BlogCity[];
  cityId?: string | null;
}

export default function ExploreByCity({
  blogs,
  currentPage,
  totalPages,
  onPageChange,
  onCityChange,
  cities,
  cityId
}: ExploreByCityProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isInitialRender, setIsInitialRender] = useState(true);

  const handleInputChange = (e: any) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
    } else {
      scrollToElement('blog-cards');
    }
  }, [currentPage]);

  return (
    <div
      className="flex flex-col gap-8 sm:gap-14 mt-4 mb-5 lg:mb-10 bg-opacity-50 h-[100%] scroll-mt-8"
      id="blog-cards"
    >
      <SearchAndFilterBlogs
        title="Explore by City"
        searchQuery={searchQuery}
        handleInputChange={handleInputChange}
        sliderCategories={cities}
        onCityChange={onCityChange}
      />
      {blogs && blogs?.length > 0 ? (
        <div className="grid grid-cols-1 md:mx-0 mmsm:grid-cols-2 md:grid-cols-2 mmd:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 mxl:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-5 4xl:grid-cols-6 gap-4">
          {blogs.map((blog, index) => (
            <CategoryBlogCard blogCardDetails={blog} key={index} />
          ))}
        </div>
      ) : (
        <div className="flex h-[calc(100vh-400px)] justify-center items-center gap-5 flex-col px-10">
          <Image
            src="/missing-data-illustration.svg"
            alt="missing data icon"
            width={272}
            height={181}
            className="w-[200px] h-[150px] sm:w-[272px] sm:h-[181px]"
          />
          <h2 className="text-black13 text-xs sm:text-base lg:text-lg font-semibold leading-none">
            {cityId === 'all-blogs'
              ? `No Blogs Data Found!`
              : `No Blogs Found for This City!`}
          </h2>
          <div className="text-center text-gray75 text-xs sm:text-base font-normal max-w-[400px]">
            {cityId === 'all-blogs'
              ? `We couldn't find information about the blogs. Please check back
            later or explore other content.`
              : `It looks like there are no blogs available for the selected city
            right now.`}
          </div>
        </div>
      )}
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={onPageChange}
        />
      )}
    </div>
  );
}
